import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    marginBottom: 200,

    '@media print': {
      pageBreakAfter: 'always !important',
      marginBottom: 0,
    },
  },
  title: {
    fontSize: 30,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  scorecardWrap: {
    marginBottom: theme.spacing(4),
  },
  scorecardTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  scoreRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
  },
  box: {
    height: 20,
    border: '1px solid #cecece',
    width: '100%',
    margin: 10,
    position: 'relative',
  },
  boxBg: {
    position: 'absolute',
    left: 2,
    top: 2,
    bottom: 2,
  },
  targetBar: {
    position: 'absolute',
    top: 2,
    bottom: 2,
    zIndex: 1,
  },
  blackBar: {
    position: 'absolute',
    width: 2,
    top: -2,
    bottom: -2,
    backgroundColor: 'black',
    zIndex: 2,
  },
  scoreTitle: {
    width: 300,
    textAlign: 'right',
  },
  scoreValue: {
    width: 300,
    textAlign: 'left',
  },
  targetDiff: {
    marginLeft: 8,
    fontSize: 12,
  },
}));

export default useStyles;
